import { memo, useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Spin } from "antd";
import { CloseOutlined, ExpandAltOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import _get from "lodash/get";
import InfiniteScroll from "react-infinite-scroll-component";
import {
  popupGetConversationListRequest,
  openChatWindow,
  closeList,
} from "providers/ChatPopupProvider/slice";
import ChatPopupConversationCell from "./ChatPopupConversationCell";

const ChatPopupList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const currentUserId = useSelector((state) =>
    _get(state, "auth.currentUser._id")
  );
  const { ids, entities, page, hasMore } = useSelector(
    (state) => state.chatPopup.conversations
  );
  const isGettingList = useSelector((state) => state.chatPopup.isGettingList);
  const openWindows = useSelector((state) => state.chatPopup.openWindows);

  useEffect(() => {
    dispatch(
      popupGetConversationListRequest({ limit: 30, page: 1 })
    );
  }, [dispatch]);

  const handleLoadMore = useCallback(() => {
    if (!isGettingList && hasMore) {
      dispatch(
        popupGetConversationListRequest({ limit: 30, page: page + 1 })
      );
    }
  }, [dispatch, isGettingList, hasMore, page]);

  const handleConversationClick = useCallback(
    (conversationId) => {
      dispatch(openChatWindow({ conversationId }));
      dispatch(closeList());
    },
    [dispatch]
  );

  const handleClose = useCallback(() => {
    dispatch(closeList());
  }, [dispatch]);

  const handleExpandToFullPage = useCallback(() => {
    dispatch(closeList());
    navigate("/fonehouse/messengers");
  }, [dispatch, navigate]);

  return (
    <div className="chat-popup-list">
      <div className="chat-popup-list-header">
        <span className="title">Tin nhắn Fonehouse</span>
        <div className="header-actions">
          <ExpandAltOutlined
            className="action-icon"
            onClick={handleExpandToFullPage}
            title="Mở trang đầy đủ"
          />
          <CloseOutlined className="action-icon" onClick={handleClose} />
        </div>
      </div>
      <div className="chat-popup-list-body" id="chat-popup-scroll">
        <InfiniteScroll
          dataLength={ids.length}
          next={handleLoadMore}
          hasMore={hasMore}
          loader={
            <div style={{ textAlign: "center", padding: 8 }}>
              <Spin size="small" />
            </div>
          }
          scrollableTarget="chat-popup-scroll"
          scrollThreshold="100px"
        >
          {ids.map((id) => {
            const conv = entities[id];
            if (!conv) return null;
            const isActive = openWindows.some(
              (w) => w.conversationId === id
            );
            return (
              <ChatPopupConversationCell
                key={id}
                data={conv}
                isActive={isActive}
                currentUserId={currentUserId}
                onClick={() => handleConversationClick(id)}
              />
            );
          })}
          {!isGettingList && ids.length === 0 && (
            <div className="chat-popup-empty">
              Không có cuộc hội thoại nào
            </div>
          )}
        </InfiniteScroll>
      </div>
    </div>
  );
};

export default memo(ChatPopupList);
